import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFeature: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFeature"><Path d="M12 1.5V8.5M12 15.5V22.5M8.5 12H1.5M15.5 12H22.5M7.90244 7.90244L6 6M16.0976 7.90244L18 6M16.0976 16.0976L18 18M7.90244 16.0976L6 18" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconFeature;
